
  function initialModal(){
    $(function () {
    //お届けサイクルアコーディオン
        

        $('.product__subscription__open').each(function(){
          $(this).on('click', function () {
            $(this).closest('.form__subscription').find('.product__subscription__cycle').slideToggle();
          });
        });

        //カートに入れるボタンクリックしたタイミングでお届けサイクルの選択を削除
        $('button.form__btn').on('click', function () {
            $(this).closest('.form__subscription').find(".productPlanSelectInput").prop("checked", false);
        });
    });

    $('#discontinued').hide();

    !function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(jQuery)}(function(e){var t,i,n,o=[],l=document,r=window,f=l.documentElement;function a(){if(o.length){var n,a,d,h=0,c=e.map(o,function(e){var t=e.data.selector,i=e.$element;return t?i.find(t):i});for(t=t||((d={height:r.innerHeight,width:r.innerWidth}).height||!(n=l.compatMode)&&e.support.boxModel||(d={height:(a="CSS1Compat"===n?f:l.body).clientHeight,width:a.clientWidth}),d),i=i||{top:r.pageYOffset||f.scrollTop||l.body.scrollTop,left:r.pageXOffset||f.scrollLeft||l.body.scrollLeft};h<o.length;h++)if(e.contains(f,c[h][0])){var s=e(c[h]),u={height:s[0].offsetHeight,width:s[0].offsetWidth},g=s.offset(),p=s.data("inview");if(!i||!t)return;g.top+170+u.height>i.top&&g.top+170<i.top+t.height&&g.left+u.width>i.left&&g.left<i.left+t.width?p||s.data("inview",!0).trigger("inview",[!0]):p&&s.data("inview",!1).trigger("inview",[!1])}}}e.event.special.inview={add:function(t){o.push({data:t,$element:e(this),element:this}),!n&&o.length&&(n=setInterval(a,250))},remove:function(e){for(var t=0;t<o.length;t++){var i=o[t];if(i.element===this&&i.data.guid===e.guid){o.splice(t,1);break}}o.length||(clearInterval(n),n=null)}},e(r).on("scroll resize scrollstop",function(){t=i=null}),!f.addEventListener&&f.attachEvent&&f.attachEvent("onfocusin",function(){i=null})});

    $(document).ready(function(){
        document.querySelectorAll(".productPlanSelect").forEach(cycle => {
            cycle.addEventListener("click", function(e){
                document.querySelectorAll(".productPlanSelect").forEach(div => {
                    div.classList.remove("checked");
                });
                var target = e.target;
                if(target.classList.contains("checked")){
                }else{
                    document.querySelector("#selling_plan").value = e.target.dataset.plan;
                    target.classList.add("checked");
                    addSubscriptionCartClick(target);
                }
            });
        });
    });
    //wl add 20210824---------
    function compare( a, b ){
        var r = 0;
        if( a.id < b.id ){ r = -1; }
        else if( a.id > b.id ){ r = 1; }
        return r;
    }
    var tax = 1;

    async function addSubscriptionCartClick(elem) {
        let prodtct_form = elem.closest("[action='/cart/add']");
        console.log({elem})
        console.log({prodtct_form})
        let qty = prodtct_form.querySelector(".product-subscription-quantity").value;
        let variant_id = prodtct_form.querySelector("input[name='id']").value;
        let data = {quantity:qty,id:parseInt(variant_id)};
        let selling_plan = elem.dataset.plan;
        if(!selling_plan)return;
        const sellingPlanName = elem.innerHTML;
        const sellingPlanID = selling_plan;
        data['selling_plan'] = selling_plan;
        data['properties']= {
            "プラン名": sellingPlanName,
            "ID": sellingPlanID,
        };

        // const updates = {};
        //

        // if (Object.keys(updates).length > 0) {
        //     await $.ajax({
        //         type: "POST",
        //         url: "/cart/update.js",
        //         data: { updates },
        //         dataType: "json",
        //     }).catch((e) => {
        //     });
        // }

        const miniCart = document.querySelector('cart-drawer');
        console.log({miniCart})
        const formData = {
        items: [
            {
            id: parseInt(variant_id),
            quantity: qty,
            selling_plan,
            properties: {
                "プラン名": sellingPlanName,
                "ID": sellingPlanID,
            }
            }
        ],
        sections: miniCart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
        }

        const additionalProducts = window.JMO.cartMethod.getAdditionalProducts();
        if(additionalProducts.length > 0){
          const additionalItems = additionalProducts.map((product) => ({
              id: product.id,
              quantity: 1
          }));
          formData.items = formData.items.concat(additionalItems);
        }

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            dataType:"json",
        }).then(function (response) {
            //成功時
            console.log({response})
            // getCart();
            if (miniCart) {
                setTimeout(() => { miniCart.renderContents(response) }, 1000)
                // miniCart.renderContents(response);
                // document.querySelector('cart-drawer')?.openMenuDrawer();
            }
        })
        .then(() => {
            console.log('then')
          document.querySelector('cart-drawer')?.classList.remove('is-empty');
        })
        .fail((e) => {
          console.log(e);
          miniCart.renderContents({sections: {}})
        });
    }
    getCart();
    function makeVariantPullDown(i, item){
        let selected = "";
        if (item.quantity === i) {
        selected = "selected";
        }
        return '\
            <option value="' + i + '" ' + selected + '>' + i + '</option>\
        ';
    }
    function makeTrRow(){
        return '\
                <div data-sku="%%line_item.variant.sku%%" data-selling-plan="%%line_item.variant.selling_plan_allocation%%" data-engrave="" data-loop="1" class="product form__row  %%hide_class_name%%" data-id="39342485209153" data-variant-id="39342485209153">\
                <div class="product__image lazy" loading="lazy"><a href="%%line_item.product.url%%"><img src="%%line_item.product.image%%" alt="%%line_item.product.alt%%" class="table__thumbnail"></a></div><!-- /.product__image -->\
                <div class="product__content"><h5><a href="%%line_item.product.url%%">%%line_item.product.title%%</a></h5>\
                    %%properties%%\
                    <div class="qty-engrave-wrap">\
                    <div class="product__quantity"  data-attr="Quantity">\
                        <div class="select table__quantity" data-attr="Quantity">\
                        <select id="updates_%%line_item.key%%" name="updates[%%line_item.key%%]" class="field field--quantity quantity_pull" data-id="%%line_item.variant_id%%" data-lineitem="%%forloop.index%%" data-key="%%line_item.key%%">\
                        %%makeVariantPullDown%%\
                        </select>\
                        </div><!-- /.select -->\
                        <div class="product__price" data-attr="Price">\
                        <small></small><span>%%line_item.product.price%%</span>\
                            <span>税込</span>\
                        </div><!-- /.product__price -->\
                    </div><!-- /.product__quantity -->\
                    </div><!-- /.qty-engrave-wrap -->\
                </div><!-- /.product__content -->\
                <a class="product__remove btn-close__product" onclick="removeTrClicked(\'%%line_item.key%%\');" data-remove-item-id="%%line_item.key%%"></a>\
                </div><!-- /.product form__row-->\
        '
    }
    var cartItems;
    function makeCartTags(tempCartItems){
        let list_tags = "";
        let loop_idx = 1;
        let item_count = 0;
        let isSubscription = false;
        let subscriptionCount = 0;
        let hideDiscountSkuString = null;
        let hideDiscountSkus = hideDiscountSkuString?.split('\n');
        for (key in tempCartItems) {
            item = tempCartItems[key];
            if(item.properties && item.properties['プラン名'] && !hideDiscountSkus.includes(item.sku)){
                subscriptionCount += item.quantity;
            }
        }
        for (key in tempCartItems) {
            item = tempCartItems[key];
            if (item.tag_gwp < 0) {
                item_count += item.quantity;
            }
            list_tag = makeTrRow();
            list_tag = replaceHtmlTag(loop_idx, item, list_tag,subscriptionCount);
            list_tags += list_tag;
            loop_idx++
            if(item.selling_plan_allocation){
                isSubscription = true;
            }
        }

        if(isSubscription){
        }else{
            $("#subscription-discount").html('');
            $("#subscription-attention").html('');
        }
        // $(".not-empty-popup-area").append(list_tags);
        $(".cart-count-bubble span:first-child").html(item_count);
    }
    function getProduct(cartItems) {
        let cart_item_length = cartItems.length;
        let tempCartItems = new Array();
        for (let idx = 0; idx < cart_item_length; idx++) {
            let item = "";
            item = cartItems[idx];
            jQuery.ajax({
                type: 'get',
                url: '/products/' + item.handle + '.js',
                dataType: 'json'
            })
            .then(function (response) {
            //cartItems[key]product_tags = 1;

            let product = response;
            //alert(product.title);
            let tag_gwp = $.inArray('GWP', product.tags);
            item.tag_gwp = tag_gwp;
            tempCartItems.push(item);
            if (tempCartItems.length == cart_item_length) {
            makeCartTags(tempCartItems);
            }

            
            });
        }
    }

    function getCart() {
        jQuery.ajax({
            type: 'get',
            url: '/cart.js',
            dataType: 'json'
        })
        .then(function (response) {
            
        })
    }

    function replaceHtmlTag(loop_idx, item, list_tag,subscriptionCount){
        list_tag = list_tag.replace(/%%line_item.product.url%%/g, item.url);
        //セット商品以外
        let hide_class_name = '';
        if (item.tag_gwp >= 0) {
        hide_class_name = 'gwp_hidden';
        }
        list_tag = list_tag.replace(/%%hide_class_name%%/g, hide_class_name);
        if (item.featured_image != undefined) {
            image_url = item.featured_image.url.replace(/https:/g, "");
            list_tag = list_tag.replace(/%%line_item.product.image%%/g, image_url);
            list_tag = list_tag.replace(/%%line_item.product.alt%%/g, item.featured_image.alt);
        }
        list_tag = list_tag.replace(/%%line_item.product.title%%/g, item.title);
        list_tag = list_tag.replace(/%%line_item.key%%/g, item.key);
        list_tag = list_tag.replace(/%%line_item.variant_id%%/g, item.variant_id);
        list_tag = list_tag.replace(/%%forloop.index%%/g, loop_idx);
        price = Shopify.formatMoney(item.price * tax, "");
        //console.log(item.price)
        list_tag = list_tag.replace(/%%line_item.product.price%%/g, price);
        list_tag = list_tag.replace(/%%line_item.product.handle%%/g, item.handle);
        list_tag = list_tag.replace(/%%line_item.variant.sku%%/g, item.sku);
        list_tag = list_tag.replace(/%%line_item.variant.selling_plan_allocation%%/g, item.selling_plan_allocation ? "true" : "false");
        option_tags = "";
        for (i = 1; i <= 12; i++){
            option_tag = makeVariantPullDown(i, item);
            option_tags += option_tag;
        }
        list_tag = list_tag.replace(/%%makeVariantPullDown%%/g, option_tags);
        let propertiesHtml = "";
            if(item.properties && item.properties['フォント']){
                propertiesHtml += `<div class="block--engrave"><div class="first"><span class="label">刻印サービス</span><div class="second">フォント:${item.properties['フォント']}<br>テキスト:${item.properties['テキスト']}</div></div></div>`;
            }
            if(item.properties && item.properties['プラン名']){
                propertiesHtml += `<div class="block--engrave"><div class="first"><span class="label">定期お届け便</span><div class="second">お届けサイクル【${item.properties['プラン名']}】<br>`;
                propertiesHtml += `</div></div></div>`;
            }
            list_tag = list_tag.replace(/%%properties%%/g, propertiesHtml);
            return list_tag;
    } // バリアント削除

    function removeTrClicked(key) {
        data = {quantity:0,id:key}
        $.ajax({
            type: "POST",
            url: '/cart/change.js',
            data: data,
            dataType:"json",
        }).then(r => {
            //成功時
            getCart();
        });
    }

    // 数量変更
    $(document).on("change", ".quantity_pull", function () {
    let quantity = $(this).val();
    let key = $(this).data("key");
    data = {quantity:quantity,id:key}
    $.ajax({
        type: "POST",
        url: '/cart/change.js',
        data: data,
        dataType:"json",
    }).then(function (response) {
        //成功時
        getCart();
    })
    .catch((e) => {
    });
    });

};
initialModal();
